export default {
    "stringValue": "N"
}